import React from 'react';

/**
 * Fixed, blurred, darkened photo behind the whole page. Sits at z-index -1 so
 * page content (and opaque panels) render on top, while transparent gutters let
 * the blurred image show through for an atmospheric backdrop.
 *
 * The page wrapper that uses this should set `background: 'transparent'` so the
 * backdrop is visible behind it.
 */
export default function PageBackdrop({
  src,
  blur = 14,
  darken = 0.84,
}: {
  src: string;
  blur?: number;
  darken?: number;
}) {
  return (
    <div
      aria-hidden="true"
      style={{ position: 'fixed', inset: 0, zIndex: -1, pointerEvents: 'none', overflow: 'hidden' }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url('${src}')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: `blur(${blur}px)`,
          transform: 'scale(1.12)',
        }}
      />
      <div style={{ position: 'absolute', inset: 0, background: `rgba(0,0,0,${darken})` }} />
    </div>
  );
}
